import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import AppFooter from "@/components/AppFooter";
import Logo from "@/components/Logo";
import { ArrowLeft } from "lucide-react";

export default function LegalPageShell({ title, intro, sections, testId = "legal-page" }) {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-ag-paper ag-paper-grain" data-testid={testId}>
      <div className="max-w-3xl mx-auto px-6 lg:px-8 pt-12 pb-8 ag-fade-in">
        <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-ag-ink mb-8">
          <ArrowLeft className="h-3.5 w-3.5" /> {t.common.backHome}
        </Link>
        <header className="mb-10">
          <Logo variant="full" tone="light" className="h-14 w-auto mb-6 -ml-1" />
          <h1 className="font-serif text-4xl md:text-5xl text-ag-ink mb-4 leading-tight">{title}</h1>
          {intro ? <p className="text-slate-600 max-w-2xl leading-relaxed text-[15px]">{intro}</p> : null}
        </header>

        <article className="space-y-10">
          {sections.map((sec, i) => (
            <section key={i} className="ag-fade-in" style={{ animationDelay: `${i * 50}ms` }}>
              {sec.title ? (
                <h2 className="font-serif text-2xl text-ag-ink mb-3 leading-snug">{sec.title}</h2>
              ) : null}
              {Array.isArray(sec.body) ? (
                <div className="space-y-3 text-[15px] text-slate-700 leading-relaxed">
                  {sec.body.map((p, j) => (
                    typeof p === "string"
                      ? <p key={j}>{p}</p>
                      : <p key={j} dangerouslySetInnerHTML={{ __html: p.html }} />
                  ))}
                </div>
              ) : (
                <p className="text-[15px] text-slate-700 leading-relaxed whitespace-pre-line">{sec.body}</p>
              )}
              {sec.bullets ? (
                <ul className="mt-4 space-y-2 text-[15px] text-slate-700">
                  {sec.bullets.map((b, k) => (
                    <li key={k} className="flex items-start gap-3">
                      <span className="mt-2 h-1.5 w-1.5 rounded-full bg-emerald-600 shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              ) : null}
            </section>
          ))}
        </article>

        <AppFooter />
      </div>
    </div>
  );
}
